import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#1A1A2E] text-gray-400 py-10 text-center text-sm border-t border-white/10" data-id="element-37">
        <div className="max-w-7xl mx-auto px-4" data-id="element-38">
          <div className="flex items-center justify-center gap-2 mb-4 text-gray-500" data-id="element-39">
            <Shield className="w-4 h-4" data-id="element-40" />
            <span className="text-xs uppercase tracking-wider font-semibold" data-id="element-41">
              Plan 7D Control
            </span>
          </div>

          <p className="mb-4" data-id="element-42">
            © {new Date().getFullYear()} Plan 7D Control. Todos los derechos
            reservados.
          </p>

          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-43">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-44">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-45">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-46">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-xs max-w-2xl mx-auto opacity-60" data-id="element-47">
            Descargo de responsabilidad: Este producto no sustituye el consejo
            médico profesional. Consulte a su médico antes de realizar cambios
            en su dieta o régimen de suplementos.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-48">
        <p className="font-semibold text-[#1A1A2E]" data-id="element-49">
          Última actualización: Marzo 2026
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-50">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-51">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital: nombre, dirección de correo
          electrónico y datos de pago. No almacenamos información de tarjetas de
          crédito en nuestros servidores.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-52">
          2. Uso de la Información
        </h3>
        <p data-id="element-53">
          Tu información personal se utiliza exclusivamente para: procesar tu
          pedido, enviarte el material digital adquirido y, si lo autorizas,
          enviarte comunicaciones relacionadas con el producto. Nunca vendemos
          ni compartimos tu información con terceros para fines de marketing.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-54">
          3. Protección de Datos
        </h3>
        <p data-id="element-55">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Todas las transacciones se procesan
          a través de plataformas de pago seguras con encriptación SSL.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-56">4. Cookies</h3>
        <p data-id="element-57">
          Utilizamos cookies esenciales para el funcionamiento del sitio web y
          cookies analíticas para mejorar tu experiencia. Puedes desactivar las
          cookies en la configuración de tu navegador.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-58">
          5. Tus Derechos
        </h3>
        <p data-id="element-59">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          contactarnos a través de los canales indicados en tu correo de
          confirmación de compra.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-60">
        <p className="font-semibold text-[#1A1A2E]" data-id="element-61">
          Última actualización: Marzo 2026
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-62">
          1. Naturaleza del Producto
        </h3>
        <p data-id="element-63">
          El Plan 7D Control es un producto digital educativo e informativo. No
          constituye asesoramiento médico, diagnóstico ni tratamiento. Siempre
          consulte a un profesional de la salud antes de modificar su dieta,
          régimen de suplementos o tratamiento médico.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-64">
          2. Entrega del Producto
        </h3>
        <p data-id="element-65">
          Al completar la compra, recibirás acceso inmediato al material digital
          a través del correo electrónico proporcionado. Es tu responsabilidad
          proporcionar una dirección de correo electrónico válida y verificar tu
          bandeja de entrada, incluyendo la carpeta de spam.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-66">
          3. Uso Personal
        </h3>
        <p data-id="element-67">
          El material adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, modificación o reventa
          del contenido sin autorización expresa por escrito.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-68">
          4. Resultados
        </h3>
        <p data-id="element-69">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que estos dependen de múltiples factores
          individuales, incluyendo el estado de salud, la adherencia al plan y
          otros factores personales.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-70">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-71">
          Plan 7D Control no se hace responsable de cualquier efecto adverso
          derivado del uso de los suplementos o cambios alimenticios sugeridos.
          El usuario asume la responsabilidad total de consultar con su médico
          antes de implementar cualquier recomendación del programa.
        </p>

        <h3 className="font-bold text-[#1A1A2E] text-base mt-4" data-id="element-72">
          6. Política de Reembolso
        </h3>
        <p data-id="element-73">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. Si experimentas problemas técnicos para
          acceder al material, contáctanos y resolveremos la situación.
        </p>
      </LegalModal>
    </>;
}